/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import { UNAUTHORIZED } from '@/middlewares/httpClient';
import { ErrorLevel } from '@/store/errors/models';
import VueI18n from 'vue-i18n';

/**
 * Dispatch the error action to show the Error message on Toast
 *
 * @param {*} err
 * @param {*} dispatch
 */
export const handleErrorMessage = (err: any, dispatch: any, serviceName: string) => {
  if (err.response) {
    const { response } = err;
    if (response.status !== UNAUTHORIZED) {
      dispatch('error/SET_ERROR', {
        error: response.data,
        service: serviceName,
        level: ErrorLevel.ERROR,
      }, { root: true });
    }
    console.error(response.data);
  } else {
    dispatch('error/SET_ERROR', {
      error: err.message,
      service: serviceName,
      level: ErrorLevel.ERROR,
    }, { root: true });
    console.error(err);
  }
};

/**
 * Dispatch the error action to show the Info message on Toast
 *
 * @param {string} message
 * @param {*} dispatch
 */
export const handleInfoMessage = (message: string, dispatch: any) => {
  if (message && dispatch) {
    dispatch('error/SET_ERROR', {
      error: message,
      level: ErrorLevel.INFO,
    }, { root: true });
  }
};
